import React, { useState, useEffect } from 'react';
import styles from './UserKycStepOne.module.css';
import lock_icon from '../../../images/icons/UserKycIcons/lock_icon.svg';
import pending_icon from '../../../images/icons/UserKycIcons/pending_icon.svg';
import verified_icon from '../../../images/icons/UserKycIcons/verified_icon.svg';

function CommonFirstStepCard(props) {
  const {
    container,
    overlay,
    lock,
    comming_soon,
    pending_or_verified_box
  } = styles;
  const {
    img,
    textColor,
    ColoredArrow,
    step,
    discription,
    bgColor
  } = props.sendeach;
  const { handleSelectData, lockscreenSet = true } = props;
  return (
    <div
      style={{
        position: 'relative',
        maxWidth: '355px,'
      }}
    >
      {step !== 1 && lockscreenSet && (
        <div className={`${overlay}`}>
          <img src={lock_icon} alt="" className={`${lock}`} />
          <p className={`${comming_soon}`}>Step {step} will unlock soon</p>
        </div>
      )}

      <div
        className={`${container} font-roboto ${bgColor}`}
        onClick={() => {
          handleSelectData();
        }}
      >
        <div>
          <img src={img} alt="" style={{ width: '92px', height: '57px' }} />
        </div>
        <div className={textColor}>
          <p className="text-xs pb-2 px-1 sm:px-3">Step {step}</p>
          <p className="text-sm font-medium px-1 sm:px-3">{discription} </p>
        </div>
        {/* <div className={`${pending_or_verified_box} text-xs`}> */}
        {/* <span className="pending_box">
            <img src={pending_icon} className="inline-block pr-1" />
            <span className="text-black-950">Pending</span>
          </span> */}
        {/* <span className="verified_box">
            <img src={verified_icon} className="inline-block pr-1" />
            <span className="text-black-950">Verified</span>
          </span> */}
        {/* </div> */}
        <div className="arrow">
          <img src={ColoredArrow} alt="" className=" h-4 w-4" />
        </div>
      </div>
    </div>
  );
}
export default CommonFirstStepCard;
